import config from '@/config/config';
export default{
     imgs(url) {
        console.log(config.imgUrl,'config');
        if (!url) return '';
        let rex = /http[s]{0,1}:\/\/([\w.]+\/?)\S*/
        if (rex.test(url) || url.indexOf('@') !== -1) return url;
        return config.imgUrl + url;
    }
}